import { assign } from 'lodash'

// Root mutations
export default {
  // Logout from application. Set values to local storage
  LOGOUT() {
    localStorage.isLogged = 0
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
    localStorage.user = null
  },

  // Login into app. Set values to local storage
  LOGIN (state, payload) {
    state.isLogged = 1
    state.auth.accessToken = payload.access_token
    state.auth.expiresIn = payload.expires_in
    state.auth.loggedAt = new Date()
  },

  // Change flag in state
  SET_IS_LOGGED_FLAG (state, value) {
    state.isLogged = value
  },

  // Populate auth data from state
  POPULATE_AUTH_AT_STATE(state) {
    state.auth = {
      accessToken: localStorage.getItem('accessToken'),
      refreshToken: localStorage.getItem('refreshToken')
    }
  },

  // Populate user data from state
  POPULATE_USER_AT_STATE(state) {
    state.user = localStorage.getItem('user')
  },

  // Change user in state
  SET_USER (state, value) {
    state.user = value
  },

  SET_SURVEY_SLUG (state, value) {
    state.surveySlug = value
  },

  // Set refresh request
  REFRESH_REQUEST (state, request) {
    state.refreshRequest = request
  },

  POPULATE_ACCESS_TOKEN (state) {
    const accessToken = localStorage.getItem('accessToken')
    if (accessToken) {
      state.auth.accessToken = accessToken
    }
  },

  LOADING_MODAL_ACTIVE (state, payload) {
    state.loadingModalActive = payload
  },

  OPEN_ERRORS_MODAL (state, payload) {
    state.errors = assign({}, payload)
  },

  CLOSE_ERRORS_MODAL (state) {
    assign(state.errors, { content: [] })
  },
}
